<xpo-icon
  iconName="info"
  xpoIconSmall
  *ngIf="tooltips?.[label]"
  class="custom-tooltip"
  color="primary"
  [matTooltip]="tooltips?.[label]"
  matTooltipClass="custom-tooltip-text"
></xpo-icon>
